/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import stories from '../../http/requests/stories';
import router from '@/router';

export default {
  load({ commit }) {
    return new Promise((resolve, reject) => {
      stories
        .load()
        .then(response => {
          console.log('Commit data', response);
          commit('SET_STORIES_DATA', response.data);
          resolve(response.data);
        })
        .catch(error => {
          reject(error.message);
        });
    });
  }
};
